let METERS = ["2/4","3/4","4/4","5/4","6/4","12/8","3/4"];
let NB_BEATS = [2,3,4,5,6,12,3];
export { METERS as default, METERS, NB_BEATS};



